<template>
  <div class="fav-main flex-col">
    <div class="top">
      <div class="flex-row header-ctrl">
        <!-- <van-icon name="arrow-left" class="icon-back" @click="goback" /> -->
        <i class="iconfont iconarrowleft-outline"
          @click="goback"
          style="font-size: 26px"></i>
        <div class="header-right">
          <div v-show="isEdit"
            class="btn-cancel">
            <i class="iconfont iconPencil"
              style="font-size: 0.875rem"></i>
            <span @click="edit">{{ $t("common.cancel") }}</span>
          </div>
          <div v-show="!isEdit">
            <i class="iconfont iconPencil"
              style="font-size: 0.875rem"></i>
            <span @click="edit">{{ $t("common.edit") }}</span>
          </div>
        </div>
      </div>
      <div class="header-info">
        {{ $t("userCollection") }}
      </div>
    </div>
    <div class="cont-center">
      <van-tabs ref="tabs"
        v-model="active"
        style="height: 100%"
        @click="tabClick"
        @change="tabChange">

        <van-tab title="机构联系人"
          title-style="flex:1.2"
          class="tab-org">
          <contractor-list :page-type="pageType"
            :is-edit="isEdit"
            ref="contractor"
            id='his-contractor'></contractor-list>
        </van-tab>

        <van-tab title="公司联系人"
          title-style="flex:1.2"
          class="tab-org">
          <contractor-list-company :page-type="pageType"
            :is-edit="isEdit"
            ref="contractorCompany"
            id='his-company-contractor'></contractor-list-company>
        </van-tab>

        <van-tab title="机构"
          class="tab-org tab-pad">
          <org-list :page-type="pageType"
            :is-edit="isEdit"
            ref="orgList"
            id='his-org'></org-list>
        </van-tab>
        <van-tab title="公司"
          class="tab-org tab-pad">
          <invested-list ref="invested"
            :page-type="pageType"
            :is-edit="isEdit"
            id='his-company'></invested-list>
        </van-tab>

        <van-tab title="市场情报"
          class="tab-org tab-pad">
          <news-list :news-type="newsTypeActive"
            :is-edit="isEdit"
            ref="marketNews"
            id='his-news'></news-list>
        </van-tab>
      </van-tabs>

      <van-action-sheet v-model="isEdit"
        :actions="actions"
        :overlay="false"
        :lock-scroll="false"
        @select="onActionSelect" />
    </div>
  </div>
</template>

<script>
import webService from "@network/webService";
import FavoriteItem from "./FavoriteItem";
import OrgList from "@components/content/org/OrgList";
import InvestedList from "@components/content/invested/InvestedList";
import ContractorList from "@components/content/contractor/ContractorList";
import ContractorListCompany from "@components/content/contractor/ContractorListCompany";
import NewsList from "../overview/NewsList";
import scollerLocation from '@/common/scollerLocation';
import { searchModel } from "@common/common";
import common from "@common/common";
import { Dialog } from "vant";
export default {
  mixins: [],
  data () {
    return {
      active: 0,
      newsTypeActive: 2,
      searchModel: null,
      list: [],
      loading: false,
      finished: false,
      isEdit: false,
      pageType: common.searchTypeEnum.contractorCollect,
      actions: [
        {
          id: 1,
          name: "删除",
          color: "#c52a1a",
        },
        {
          id: 2,
          name: "全选",
          color: "dimgrey",
        },
      ],
    };
  },
  components: {
    FavoriteItem,
    OrgList,
    InvestedList,
    ContractorList,
    ContractorListCompany,
    NewsList
  },
  activated () {
    console.log("fav: activated", this.active);
    let outlink = sessionStorage.getItem("outlink");
    if (outlink == 1) {
      sessionStorage.setItem("outlink", -1);
    }
    scollerLocation.recoverLocation('his-contractor');
    scollerLocation.recoverLocation('his-company-contractor');
    scollerLocation.recoverLocation('his-org');
    scollerLocation.recoverLocation('his-company');
    scollerLocation.recoverLocation('his-news');
  },
  beforeRouteLeave (to, from, next) {
    var dataList = document.querySelector('#his-contractor .cont-list');
    if (dataList) {
      scollerLocation.saveLocation('his-contractor', dataList);
    }
    var datacompanyList = document.querySelector('#his-company-contractor .cont-list');
    if (datacompanyList) {
      scollerLocation.saveLocation('his-company-contractor', datacompanyList);
    }
    var orgList = document.querySelector('#his-org .cont-list');
    if (orgList) {
      scollerLocation.saveLocation('his-org', orgList);
    }
    var companyList = document.querySelector('#his-company .cont-list');
    if (companyList) {
      scollerLocation.saveLocation('his-company', companyList);
    }
    var newsList = document.querySelector('#his-news .cont-list');
    if (newsList) {
      scollerLocation.saveLocation('his-news', newsList);
    }
    next();
  },
  computed: {
    curComponent () {
      let component = null;
      if (this.pageType == common.searchTypeEnum.orgCollect) {
        component = this.$refs.orgList;
      } else if (this.pageType == common.searchTypeEnum.contractorCollect) {
        component = this.$refs.contractor;
      } else if (this.pageType == common.searchTypeEnum.contractorCompanyCollect) {
        component = this.$refs.contractorCompany;
      } else if (this.pageType == common.searchTypeEnum.investedCollect) {
        component = this.$refs.invested;
      } else if (this.pageType == common.searchTypeEnum.newsTypeCollect) {
        component = this.$refs.marketNews;
      }
      return component;
    },
  },
  methods: {
    tabChange () {
      this.isEdit = false;
      this.cancelSelected();
    },
    tabClick (name, title) {
      // this._active = name;
      if (name == 0) {
        this.pageType = common.searchTypeEnum.contractorCollect;
      } else if (name == 1) {
        this.pageType = common.searchTypeEnum.contractorCompanyCollect;
      } else if (name == 2) {
        this.pageType = common.searchTypeEnum.orgCollect;
      } else if (name == 3) {
        this.pageType = common.searchTypeEnum.investedCollect;
      } else if (name == 4) {
        this.pageType = common.searchTypeEnum.newsTypeCollect;
      }

      sessionStorage.setItem("_favorite_active", name);
    },
    onActionSelect (item) {
      if (item.id == 2) {
        this.curComponent.selectAll();
      } else if (item.id == 1) {
        Dialog.confirm({
          title: "提示",
          message: "确认删除选中记录？",
        })
          .then(() => {
            this.curComponent.deleteItem();
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    selectAll () {
      if (this.curComponent)
        this.curComponent.selectAll();
    },
    deleteItem () {
      Dialog.confirm({
        title: "提示",
        message: "确认删除选中记录？",
      })
        .then(() => {
          this.curComponent.deleteItem();
        })
        .catch(() => {
          // on cancel
        });
    },
    cancelSelected () {
      if (this.curComponent)
        this.curComponent.cancelSelected();
    },
    edit () {
      this.isEdit = !this.isEdit;
      console.log(this.isEdit);
      if (!this.isEdit) {
        this.cancelSelected();
      }
    },
    goback () {
      // debugger;
      // this.$destroy();
      this.$router.back(-1);
    },
  },
  created () {
    this.active = parseInt(sessionStorage.getItem("_favorite_active"));
    this.tabClick(this.active);
  },
};
</script>

<style lang='scss' scoped>
@import "../../styles/theme.scss";
.fav-main {
  height: 100%;
}
.top {
  height: 5.6rem;
  padding: 5px 10px 0 10px;
  .header-info {
    font-size: 25px;
    padding-top: 10px;
    color: #2d2d2d;
  }
  .header-ctrl {
    height: 36px;
    align-items: center;
    .icon-back {
      font-size: $size-24;
    }
    .header-right {
      flex: 1;
      text-align: right;
      padding-right: 10px;
      // .btn-cancel {
      //     color: rgb(152, 42, 33);
      // }
    }
  }
}
.cont-center {
  height: calc(100% - 5.6rem);
  overflow: auto;
  .tab-org {
    height: 100%;
    //padding: 0 0.6rem;
  }
  .tab-pad {
    padding: 0 0.6rem;
  }
  .btns-bottom {
    position: fixed;
    bottom: 0;
    height: 4rem;
    background-color: white;
    left: 0;
    right: 0;
    line-height: 4rem;
    text-align: right;
    border-top: 1px solid #ccc;
    .btn-del {
      border-color: rgb(152, 42, 33);
      color: rgb(152, 42, 33);
      height: 2rem;
      transform: translateY(-10%);
    }
    .div-all {
      display: inline-block;
      margin-left: 20px;
      padding: 0 10px;
      height: 2rem;
    }
  }
}
/deep/ .van-tabs__content {
  height: calc(100% - 45px);
}
/deep/ .van-action-sheet__content {
  display: flex;
}

/deep/ .van-tabs__line {
  background-color: #c52a1a;
}
/deep/ .van-tabs__wrap {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/favorites/MyFavorites.vue